import { BACKEND_API_PLACEHOLDER } from "@/../environment.config";
import { fetchCurrentUserData } from "@/util/customFetch";

// sample data imports for offline dev purposes
const isOfflineDev = import.meta.env.VITE_OFFLINE_DEV === "true";
const {permissionRows} = isOfflineDev ? await import("@/tests/fixtures/PermissionRows.js") : {};

export async function getAllPermissions(headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/v1/permissions/permissions', {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getPermissionSets(headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER + '/api/v1/permissions/permissions_sets/', {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return {
    status: 200,
    data: { results: permissionRows }
  }
}

export async function getPermissionSetConfigs(permissions_set_id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/permissions/permissions_set_config?permissions_set_id=${permissions_set_id}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function postCreatePermissionSet(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/permissions/permissions_sets/new`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function postCreatePermissionSetConfig(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/permissions/permissions_set_config/new`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function putEditPermissionSet(id, requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/permissions/permissions_set?permissions_set_id=${id}`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function putEditPermissionConfig(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/permissions/permissions_set_config/edit`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function putEditUserManagementAccess(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/permissions/set_user_management`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function putEditAdminPrivileges(requestBody, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/permissions/set_is_admin`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify({requestBody})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getPermissionLogsQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/v1/permissions/logs/query?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

